export default class anchorlinks {
  constructor(element) {
    this.page = element;

    const langElement = this.page.querySelector("[lang]");
    this.lang = langElement ? langElement.getAttribute("lang") : "sv";
    
    const sections = [
      ".u-container.wysiwyg h2",
    ];

    this.sections = Array.from(
      element.querySelectorAll(sections.join(", "))
    );

    this.linksWrapper = element.querySelector(".js-jump-menu-wrapper");

    this.items = [];
    this.asyncAnchorLinksRender();
  }

  asyncAnchorLinksRender = async () => {
    const result = await this.renderAnchorLinks();

    if (result) {
      this.makeLinksClickable();
    }
  };

  renderAnchorLinks() {
    return new Promise((resolve) => {
      setTimeout(() => {
        this.getItems(this.sections);



        if (this.items.length < 2) {
          resolve(false);
          return;
        }

        const headingText = this.lang === "en" ? "Page content" : "Innehåll på sidan";
        let content = '<div class="anchor-links">';
        content += `<p class="anchor-links__title">${headingText}</p>`;
        content += '<ul class="anchor-links__list">';

        this.items.map((item) => {
          content += "<li>";
          content += `<span class="anchor-links__link" data-href="${this.stripString(
            item.element.innerText,
          )} data-position-x="${item.position.left}" data-position-y="${
            item.position.top
          }" tabindex="0" role="link">${item.element.innerText}</span>`;
          content += "</li>";
        });

        content += "</ul>";
        content += "</div >";


        this.linksWrapper.innerHTML += content;


        resolve(true);
      }, 100);
    });
  }

  makeLinksClickable() {
    let anchorLinks = Array.from(
      this.page.getElementsByClassName("anchor-links__link"),
    );

    anchorLinks.map((link) => {
      link.addEventListener("click", (e) => {
        window.scrollTo({
          top: link.getAttribute("data-position-y"),
          left: link.getAttribute("data-position-x"),
          behavior: "smooth",
        });
      });
    });
  }

  getItems(sections) {
    sections.map((section) => {
      let sectionPosition = section.getBoundingClientRect();
      // let sectionHeading = section.querySelector("h1, h2");
      const item = {
        position: {
          top: sectionPosition.top < 0 ? (sectionPosition.top + sectionPosition.height) : (sectionPosition.top - sectionPosition.height),
          left: sectionPosition.left,
        },
        element: section,
      };

      this.items.push(item);
    });
  }

  stripString(item) {
    let string = item.toLowerCase();
    let result = string.replace("/ /g", "-");

    return result;
  }
}
